import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

// Config
import { Config } from '../../providers/config/config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8;'
  })
}

@Injectable()
export class PaymentService {
  data: any;

  constructor( 
    public http: HttpClient
  ) {
  }

  savePaymentEntry( paymentEntry ) {
    // This only saves recertification payment data right now
    //return this.http.post( Config.API_ROOT_EVENT_REGISTRATION + 'payment', JSON.stringify(paymentEntry), httpOptions );
  }
}


// WEBPACK FOOTER //
// ./src/providers/payment/payment-service.ts